import { action, observable } from "mobx";
import { message } from "antd";
import Manager, { IManager } from "../services/Manager";
import { STATUS_VALIDATION_ERROR } from "../constants/http";

interface IErrors {
  client?: string[] | null;
  epi?: string[] | null;
  means_of_transportation?: string[] | null;
  carrier?: string[] | null;
  driver?: string[] | null;
  consignment_items?: string[] | null;
  invoice?: string[] | null;
  currency?: string[] | null;
  brutto?: string[] | null;
  cmr?: string[] | null;
  date_cmr?: string[] | null;
  consignor?: string[] | null;
  border_checkpoint_name?: string[] | null;
  customs_code_and_office_name?: string[] | null;
  customs_code?: string[] | null;
  way?: string[] | null;
  note?: string[] | null;
  measure_code?: string[] | null;
  warranty?: string[] | null;
}

class CreateDeclarantStore {
  @observable
  private _errors: IErrors = {};

  get errors(): IErrors {
    return this._errors;
  }

  private manager: IManager = Manager;

  @action
  create(params: Object): Promise<Response> {
    return this.manager
      .createDeclarant(params)
      .then(async (response) => {
        const data = await response.json();

        this._errors = {};

        message.success(data.message);
      })
      .catch(async (response) => {
        const data = await response.json();

        if (response.status === STATUS_VALIDATION_ERROR) {
          this._errors = data.errors;
        }

        message.error(data.message);

        return response;
      });
  }
}

export default CreateDeclarantStore;
